//save as site: {
// 1day:{}
//1hour:{}
// }
//event driven development
import { useEffect } from 'react';

import { cachedSetEconomicsKpiDataSite } from '@flexo/reducers';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';

const ENV = (import.meta as any).env;

export const EconomicsKpiSiteResolver = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);

  const pathSegment = location.pathname.split('/')[1];

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {
    if (!pathSegment.includes('site') && !pathSegment.includes('household')) {
      return;
    }

    const SITE_ID = params?.id || metadata?.selectedEntity?.siteId || null;

    if (!SITE_ID) {
      return;
    }

    // dispatch(KPI.ResetNamedKpiFields([
    //   'EconomicsCommunity',
    //   'communityRanking',
    //   'EconomicsMember',
    //   'memberRanking',
    // ] as any));

    // Token auto-injected by httpService interceptor
    dispatch(
      cachedSetEconomicsKpiDataSite({
        SITE_ID,
        selectedDate,
        selectedTimeSet,
      }) as any
    );
  }

  useEffect(() => {
    init();
  }, [
    params.id,
    metadata?.selectedEntity,
    selectedDate,
    selectedTimeSet,
    pathSegment,
  ]);

  return <></>;
};
